export const REQUEST_GATEWAY_LIST = 'gateways/REQUEST_GATEWAY_LIST';
export const RECEIVE_GATEWAY_LIST = 'gateways/RECEIVE_GATEWAY_LIST';
export const GATEWAY_LIST_FAILURE = 'gateways/GATEWAY_LIST_FAILURE';

export const REQUEST_GATEWAY = 'gateways/REQUEST_GATEWAY';
export const RECEIVE_GATEWAY = 'gateways/RECEIVE_GATEWAY';
export const GATEWAY_FAILURE = 'gateways/GATEWAY_FAILURE';
export const RECEIVE_UPDATE_GATEWAY = 'gateways/RECEIVE_UPDATE_GATEWAY';